import { getWithShareToken } from './base/api-with-optional-code'

const getSharedCustomerDetail = (customerId, shareToken) =>
    getWithShareToken(`/customer/${customerId}`, shareToken)

export default getSharedCustomerDetail
